<template>
    <bill-shell>
        <!-- Pricing Tables First -->
        <section id="more" class="section py-5 bg-white">
            <div class="container text-left">
                <h1 class="text-8 font-weight-bold mb-4 mt-2">
                    Latest Wi-Fi Packages February 2025
                </h1>

                <!-- TelOne USD Packages Table -->
                <h2 class="text-7 font-weight-bold mb-4 mt-2">
                    TelOne USD Packages
                </h2>
                <div class="table-responsive">
                    <table class="table">
                        <tbody>
                        <tr class="text-black-50">
                            <th>Package Name</th>
                            <th>Normal Data (GB)</th>
                            <th>Night Data (GB)</th>
                            <th>Price In USD</th>
                        </tr>
                        <tr>
                            <td>Copper</td>
                            <td>15</td>
                            <td>0</td>
                            <td>$5.00</td>
                        </tr>
                        <tr>
                            <td>Bronze 50GB</td>
                            <td>50</td>
                            <td>0</td>
                            <td>$10.00</td>
                        </tr>
                        <tr>
                            <td>Bronze 75GB</td>
                            <td>75</td>
                            <td>0</td>
                            <td>$20.00</td>
                        </tr>
                        <tr>
                            <td>Silver 160GB</td>
                            <td>160</td>
                            <td>0</td>
                            <td>$30.00</td>
                        </tr>
                        <tr>
                            <td>Gold 300GB</td>
                            <td>300</td>
                            <td>0</td>
                            <td>$50.00</td>
                        </tr>
                        <tr>
                            <td>Diamond 500GB</td>
                            <td>500</td>
                            <td>0</td>
                            <td>$90.00</td>
                        </tr>
                        <tr>
                            <td>Platinum</td>
                            <td>Uncapped</td>
                            <td>Uncapped</td>
                            <td>$90.00</td>
                        </tr>
                        <tr>
                            <td>1 TB Unlimited</td>
                            <td>Uncapped</td>
                            <td>Uncapped</td>
                            <td>$140.00</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <!-- TelOne ADSL Packages Table -->
                <h2 class="text-7 font-weight-bold mb-4 mt-2">
                    TelOne ADSL Packages (ZiG)
                </h2>
                <div class="table-responsive">
                    <table class="table">
                        <tbody>
                        <tr class="text-black-50">
                            <th>Package</th>
                            <th>Data (GB)</th>
                            <th>Price in ZiG</th>
                        </tr>
                        <tr>
                            <td>Home Plus</td>
                            <td>30</td>
                            <td>327</td>
                        </tr>
                        <tr>
                            <td>Home Premier</td>
                            <td>60</td>
                            <td>653</td>
                        </tr>
                        <tr>
                            <td>Home Surfer</td>
                            <td>100</td>
                            <td>1,088</td>
                        </tr>
                        <tr>
                            <td>Home Boost</td>
                            <td>200</td>
                            <td>1,740</td>
                        </tr>
                        <tr>
                            <td>Infinity Pro</td>
                            <td>500</td>
                            <td>3,643</td>
                        </tr>
                        <tr>
                            <td>Intense</td>
                            <td>Uncapped</td>
                            <td>4,365</td>
                        </tr>
                        <tr>
                            <td>Infinity Supreme</td>
                            <td>Uncapped</td>
                            <td>5,589</td>
                        </tr>
                        <tr>
                            <td>Infinity Extra</td>
                            <td>Uncapped</td>
                            <td>7,304</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>

        <!-- Original Content -->
        <section id="more" class="section py-5 bg-white">
            <div class="container text-left">
                <h1 class="text-8 font-weight-bold mb-4 mt-2">
                    Access TelOne Wi-Fi Packages Online with Magetsi!
                </h1>
                <p class="text-3">
                    Wi-Fi has become an integral part of our daily lives, so much so that after water, a Wi-Fi connection feels essential for modern living. From communication to entertainment, many aspects of our lives revolve around the availability of a reliable Wi-Fi connection. Some affordable TelOne Wi-Fi packages have made this possible.
                </p>
                <!-- Rest of the content remains unchanged -->
            </div>
        </section>

        <!-- How to Buy TelOne Wi-Fi Online Using Magetsi -->
        <section id="more" class="section py-5 bg-white">
            <div class="container text-left">
                <h2 class="text-7 font-weight-bold mb-4 mt-2">
                    How To Buy TelOne Wi-Fi Online Using Magetsi
                </h2>
                <ol class="text-3 mb-4 text-left">
                    <li>Visit Magetsi website <a href="https://www.magetsi.co.zw" target="_blank">www.magetsi.co.zw</a>.</li>
                    <li>On the homepage, select TelOne.</li>
                    <li>Choose your desired TelOne service (Direct Recharge, Recharge through pin, TelOne Voice).</li>
                    <li>Choose Your Top-Up Amount: We offer various TelOne WiFi packages to suit your needs, allowing you to select the data bundle or subscription plan you desire.</li>
                    <li>Pick Your Payment Method: Magetsi provides several secure payment options for your convenience. Choose from EcoCash, VISA, or Mastercard.</li>
                    <li>Complete the Transaction: Follow the on-screen instructions to finalize your payment. Once successful, you'll receive confirmation and your TelOne Wi-Fi account will be instantly topped up.</li>
                </ol>
                <p class="text-3 mb-4 text-left">
                    Facing Challenges? If you encounter any challenges, contact Magetsi customer support using the live chat on this website or simply open a ticket using WhatsApp (+263 785 832 033).
                </p>
            </div>
        </section>

        <!-- Rest of the sections remain unchanged -->
    </bill-shell>
</template>

<script>
import Carousel from "../../custom/carousel.vue";
import BillShell from "../bill-shell.vue";
import TariffsTable from "../../custom/tariffs-table.vue";

export default {
    name: "telone-wifi",
    components: { BillShell, TariffsTable, WelcomeInfo: () => import("../../shared/welcome-info.vue") },

    mounted() {
        const carousel = () => setTimeout(() => {
            if (this.car + 1 > 5) this.car = 1
            else this.car++

            carousel()
        }, 25000)

        carousel()
    },
    metaInfo() {
        return {
            title: "TelOne Wi-Fi Packages Online",
        }
    }
}
</script>
